import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "area"];

  connect() {
    if (this.buttonTarget) {
      this.buttonTarget.addEventListener("click", this.handleButtonClick);
    }
  }

  disconnect() {
    if (this.buttonTarget) {
      this.buttonTarget.removeEventListener("click", this.handleButtonClick);
    }
  }

  handleButtonClick = (_event) => {
    if (this.areaTarget && this.areaTarget.classList.contains("hidden")) {
      this.areaTarget.classList.remove("hidden");
    } else if (this.areaTarget) {
      this.areaTarget.classList.add("hidden");
    }
  };
}
